import { render, staticRenderFns } from "./housingXian.vue?vue&type=template&id=017a2177&scoped=true"
import script from "./housingXian.vue?vue&type=script&lang=js"
export * from "./housingXian.vue?vue&type=script&lang=js"
import style0 from "./housingXian.vue?vue&type=style&index=0&id=017a2177&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017a2177",
  null
  
)

export default component.exports